export default "__VITE_ASSET__DiKRVGvZ__"